import { cn } from "@portal/components/lib/utils";
import { SeverityDot } from "./SeverityDot";
import { ActionItem } from "./types";

export type AgentActionItemsTableProps<TAction> = {
	rows: ActionItem<TAction>[];
	onActionClick?: (row: ActionItem<TAction>) => void;
};

export const AgentActionItemsTable = <TAction,>({
	rows,
	onActionClick,
}: AgentActionItemsTableProps<TAction>) => {
	if (rows.length === 0) {
		return null;
	}

	return (
		<div
			className="min-w-0 overflow-hidden rounded-lg border border-bc-default bg-surface-base"
			data-testid="agent-action-items-table"
		>
			<table className="w-full relative table-fixed border-collapse">
				<colgroup>
					<col style={{ width: "40%" }} />
					<col style={{ width: "40%" }} />
					<col style={{ width: "20%" }} />
				</colgroup>
				<thead>
					<tr className="border-b border-bc-default bg-surface-neutral">
						<th className="pl-5 pr-3 py-2.5 text-left text-[13px] font-semibold text-primary">
							Item
						</th>
						<th className="px-3 py-2.5 text-left text-[13px] font-semibold text-primary">Reason</th>
						<th className="px-3 py-2.5 text-left text-[13px] font-semibold text-primary">Action</th>
					</tr>
				</thead>
				<tbody>
					{rows.map((row) => (
						<tr
							key={row.key}
							className="border-b border-bc-subtle bg-surface-base text-sm text-secondary last:border-b-0"
						>
							<td className="pl-5 pr-3 py-3 align-middle">
								<div className="flex items-center gap-3">
									<SeverityDot severity={row.severity} />
									<span className="font-semibold text-primary">{row.label}</span>
								</div>
							</td>
							<td className={cn("px-3 py-3 align-middle", !row.reason && "text-tertiary")}>
								{row.reason ?? "--"}
							</td>
							<td className="px-3 py-3 align-middle">
								{row.action ? (
									<button
										type="button"
										className="text-link hover:text-link-hover cursor-pointer font-medium underline-offset-2 hover:underline"
										onClick={() => onActionClick?.(row)}
									>
										{row.actionLabel}
									</button>
								) : (
									<span className="text-tertiary">{row.actionLabel}</span>
								)}
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};
